import React from 'react';

import { Panel } from 'components';
import { IntegerField } from 'components/shared';

export const CheapestItemDiscountFields = function () {
  return (
    <>
      <IntegerField label="campaigns:limit" name="cheapestItemDiscount.limit" />
      <IntegerField
        label="campaigns:threshold"
        name="cheapestItemDiscount.threshold"
        defaultValue={1}
      />
      <IntegerField label="campaigns:cycle" name="cheapestItemDiscount.cycle" defaultValue={1} />
      <IntegerField label="campaigns:offset" name="cheapestItemDiscount.offset" defaultValue={0} />
    </>
  );
};

const PromotionCheapestItemDiscountAction = function () {
  return (
    <Panel title="app:action" defaultExpanded>
      <CheapestItemDiscountFields />
    </Panel>
  );
};

PromotionCheapestItemDiscountAction.propTypes = {};

export default React.memo(PromotionCheapestItemDiscountAction);
